import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BreakpointObserver } from '@angular/cdk/layout'

export const ResponsiveBreakpoints = {
  mobile: '(min-width: 320px) and (max-width: 767px)',
  desktop: '(min-width: 768px)',
};


@Directive({
  selector: '[matches]'
})
export class MatchesDirective implements OnInit, OnDestroy {

  isMobileDevice$ = new BehaviorSubject<boolean>(false);
  destroyed$ = new Subject<boolean>();

  @Input() matches: keyof typeof ResponsiveBreakpoints;

  constructor(private tpl: TemplateRef<any>, private vcr: ViewContainerRef, public breakpointObserver: BreakpointObserver) { }

  ngOnInit() {

    const breakpoint = ResponsiveBreakpoints[this.matches];
    this.breakpointObserver.observe([breakpoint]).pipe(takeUntil(this.destroyed$)).subscribe((result) => {
      if(result.matches){
        this.vcr.createEmbeddedView(this.tpl);
      } else {
        this.vcr.clear()
      }
    })
  }

  ngOnDestroy():void{
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
